@if (!isProd) { ID: {{ id | json }}<br />
{{ standalone | json }}
<br />
{{ model | json }}
<br />
{{ form.errors | json }}
<br />
{{ mode | json }}

{{ options | json }}
<br />
} @if (standalone) {
<div>
  <nz-back-top
    [nzVisibilityHeight]="86"
    [nzTarget]="targetForAffix"
  ></nz-back-top>
</div>
}

<section fxLayout="column" fxLayoutGap="16px">
  @if (standalone && hasSubmitButton) {
  <div>
    <etoh-back-button [route]="listLink">Back to the list</etoh-back-button>
  </div>
  } @if (loading) {
  <div>
    <nz-spin nzSimple></nz-spin>
  </div>
  } @if (!loading) {
  <div class="card mat-padding-2" fxLayout="column" fxLayoutGap="16px">
    <div fxLayout="row">
      <div class="mat-h2">
        @if (!title) {
        {{ textMode.header }} {{ name }}@if (model.id) { : {{ model.id }}
        } } @if (title) {
        {{ title }}
        }
      </div>
      <span fxFlex></span>
      @if (displayedHeaderButtons?.length && hideHeaderButtons === false) {
      <nz-affix [nzTarget]="targetForAffix" [nzOffsetTop]="16">
        <div
          class="buttons"
          fxLayoutAlign="end center"
          fxLayout="row wrap"
          fxLayoutGap="4px grid"
        >
          @for (button of displayedHeaderButtons; track button.label) { @if (
          (!button.visibity || button.visibity.includes(mode)) &&
          (!button.isShow || (button?.isShow && button.isShow())) ) {
          <div>
            @if (button.buttons) {
            <button
              nz-button
              nz-dropdown
              type="button"
              nz-button
              nzType="primary"
              [nzDropdownMenu]="menu"
            >
              {{ button.label }}
              <span nz-icon nzType="down"></span>
            </button>
            <nz-dropdown-menu #menu="nzDropdownMenu">
              <ul nz-menu>
                @for (subBtn of button.buttons; track subBtn) { @if
                (subBtn.click) {
                <li nz-menu-item (click)="subBtn.click()">
                  {{ subBtn.label }}
                </li>
                } @if (!subBtn.click) {
                <a href="javascript:void(0)">Not coded</a>
                } }
              </ul>
            </nz-dropdown-menu>
            } @if (!button.buttons) { @if (button.click) {
            <button
              type="button"
              nz-button
              nzType="primary"
              (click)="button.click()"
            >
              {{ button.label }}
            </button>
            } @if (!button.click) { @if (button.link?.includes('http')) {
            <a
              nz-button
              nzType="primary"
              [href]="button.link"
              target="_blank"
              >{{ button.label }}</a
            >
            } @if (!button.link?.includes('http')) {
            <a
              nz-button
              nzType="primary"
              [routerLink]="button.link"
              [queryParams]="button.queryParams"
              >{{ button.label }}</a
            >
            } } }
          </div>
          } } @if (extraButtons?.length) {
          <div>
            <button
              nz-button
              nzType="primary"
              nzTrigger="click"
              nzShape="circle"
              nz-dropdown
              [nzDropdownMenu]="menu"
            >
              <span nz-icon nzType="more"></span>
            </button>
            <nz-dropdown-menu #menu="nzDropdownMenu">
              <ul nz-menu>
                @for (extra of extraButtons; track extra.label) {
                <li nz-menu-item (click)="extra?.click()">
                  {{ extra.label }}
                </li>
                }
              </ul>
            </nz-dropdown-menu>
          </div>
          }
        </div>
      </nz-affix>
      }
    </div>
    @if (fields?.length && model) {
    <form
      nz-form
      class="low-extra-padding"
      [formGroup]="form"
      nzLayout="vertical"
      (ngSubmit)="submit()"
    >
      <formly-form
        [model]="model"
        [fields]="fields"
        [options]="options"
        [form]="form"
      ></formly-form>
      <nz-affix [nzOffsetBottom]="16" [nzTarget]="targetForAffix">
        @if (hasSubmitButton) {
        <div fxLayout="row" fxLayoutGap="8px">
          @if (form.valid) {
          <button
            nz-button
            type="submit"
            nzType="primary"
            [disabled]="!form.valid"
            [nzLoading]="submitLoading"
          >
            {{ textMode.button }}
          </button>
          } @if (form.valid && afterCreate === 'stayOnPage' && standalone) {
          <button
            nz-button
            type="button"
            nzType="default"
            [disabled]="!form.valid"
            [nzLoading]="submitLoading"
            (click)="submitAndGoBackToList()"
          >
            {{ textMode.button }} + go back
          </button>
          } @if (!form.valid) {
          <button
            nz-popover
            #popover
            nzPopoverTitle="Why I cannot click on the submit button?"
            [nzPopoverContent]="contentTemplate"
            type="button"
            nz-button
            class="fake-disabled"
            type="button"
            nzType="primary"
          >
            {{ textMode.button }} ⚠️
          </button>
          }
          <ng-template #contentTemplate>
            The form is not valid.<br />
            Some fields are missing or invalid.
            <br />
            <br />
            <button
              nz-button
              nzSize="small"
              nzType="dashed"
              type="button"
              (click)="why()"
              nzDanger
            >
              Show me errors on the form.
            </button>
          </ng-template>
          @if (standalone && hasExtraSubmitButton) { @for (button of
          submitButtons; track button) {
          <button
            nz-button
            nzType="default"
            type="button"
            [disabled]="!form.valid"
            [nzLoading]="submitLoading"
            (click)="submit(button.afterSubmit)"
          >
            <span nz-icon nzType="plus"></span>
            {{ button.label }}
          </button>
          } } @if (initialModel) {
          <button
            nz-button
            type="button"
            nzType="dashed"
            (click)="model = initialModel"
          >
            Cancel modifications
          </button>
          }
        </div>
        }
      </nz-affix>
    </form>
    }
  </div>
  }

  <ng-content></ng-content>

  @if (userService.role$.value === 'user' && displayedDataTabs?.length) {
  <div class="card mat-padding-2">
    <div class="mat-h2">Linked data</div>
    @defer (on viewport) {
    <etoh-tabs-table [tabs]="displayedDataTabs"></etoh-tabs-table>
    } @placeholder {
    <nz-spin nzSimple></nz-spin>
    }
  </div>
  } @if (!forceMode && mode === 'edit' && userService.role$.value === 'user') {
  <div class="card mat-padding-2">
    <div class="mat-h2">Timeline</div>
    @defer (on viewport) {
    <etoh-history-timeline
      [id]="id"
      [dataType]="dataType"
    ></etoh-history-timeline>
    } @placeholder {
    <nz-spin nzSimple></nz-spin>
    }
  </div>
  }
</section>
